import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "inst-title" }, "생산 가능 크기 검사", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "생산 장비 하나로 한 번에 만들기 힘든 경우 생산 가능 크기 검사 실패가 나오게 됩니다. \n이 경우 완전히 제조가 불가능한 것은 아니기에 '한양3D팩토리 홈페이지 > 문의하기' 로 글을 남겨주시면 생산 가능한 가이드를 제공 해드립니다. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inst-subtitle" }, "[해결방법]", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, [
  /*#__PURE__*/_createTextVNode("· 모델을 분할하여 재접합"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("· 한양3D팩토리 문의하기 를 통해 생산가이드 제공 받기")
], -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_5))
}